export const pipedreamUrlsDict = {
  ru: 'https://eo3fot4v15t5ang.m.pipedream.net',
  en: 'https://eow2fof6d50reul.m.pipedream.net',
  // TODO
  de: 'https://eow2fof6d50reul.m.pipedream.net',
  tr: 'https://eow2fof6d50reul.m.pipedream.net',
};
export const analyticsFormIdDict = {
  ru: 'imin-164',
  en: 'imin-165',
  // TODO
  de: 'imin-165',
  tr: 'imin-165',
};
